import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { FlyoutExternalsiteComponent } from '../../flyout/flyout-externalsite/flyout-externalsite.component';
import { FlyoutExternalsiteModule } from '../../flyout/flyout-externalsite/flyout-externalsite.module';
import { CommonService } from '../../services/common.service';
// This Module's Components
import { LogoComponent } from './logo.component';

@NgModule({
  imports: [
    CommonModule,
    DataLayerModule,
    FlyoutExternalsiteModule,
    ModalModule.forRoot()
  ],
  declarations: [LogoComponent],
  exports: [LogoComponent],
  providers: [CommonService]
})
export class LogoModule {}
